import { SxProps, Theme, Box } from '@mui/material';
import { styled } from '@mui/styles';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

const StyledTextEditorContent = styled(Box)(() => ({
    wordBreak: 'break-word',
    '& p': { margin: 0 },
    '& a': {
        cursor: 'pointer',
        fontWeight: 'bold'
    },
    '& ul, & ol': {
        display: 'inline-block',
        textAlign: 'left',
        marginTop: 0
    }
}));

export const sanitizeText = (text: string, contentStyles?: SxProps<Theme>) => {
    // Add a hook to make all links open a new window
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
        // set all elements owning target to target=_blank
        if ('target' in node) {
            node.setAttribute('target', '_blank');
            node.setAttribute('rel', 'noopener noreferrer');
        }
    });

    const newContent = text.replaceAll('<p></p>', '<br>').replaceAll('\n', '<br>');

    const sanitazedContent = DOMPurify.sanitize(newContent, {
        ALLOWED_TAGS: ['p', 'strong', 'a', 'em', 'u', 'ol', 'ul', 'li', 'br'],
        ALLOWED_ATTR: ['href', 'style', 'target', 'rel'],
        KEEP_CONTENT: true,
        FORCE_BODY: true
    });

    return (
        <StyledTextEditorContent sx={contentStyles}>
            {parse(`${sanitazedContent}`)}
        </StyledTextEditorContent>
    );
};

export const cleanText = (text: string): string => {
    const clean = DOMPurify.sanitize(text, { ALLOWED_TAGS: [] });

    const temp = document.createElement('div');
    temp.innerHTML = clean;

    return temp.textContent || temp.innerText || '';
};

export const sanitizeForFilename = (name: string): string => {
    return name.replace(/[\/\\:\*\?"<>\|\.]/g, '');
};
